import React from 'react';

interface StatsHeaderProps {
  homeMatches: number;
  awayMatches: number;
  homePoints: number;
  awayPoints: number;
}

const StatsHeader: React.FC<StatsHeaderProps> = ({ 
  homeMatches, 
  awayMatches, 
  homePoints, 
  awayPoints 
}) => {
  return (
    <>
      <tr className="border-b">
        <td className="py-2 text-right font-medium text-blue-600">
          {homeMatches}
        </td>
        <td className="py-2 text-center font-semibold text-gray-600">Matches</td>
        <td className="py-2 text-left font-medium text-red-600">
          {awayMatches}
        </td>
      </tr>
      <tr className="border-b">
        <td className="py-2 text-right font-medium text-blue-600">
          {homePoints}
        </td>
        <td className="py-2 text-center font-semibold text-gray-600">Points</td>
        <td className="py-2 text-left font-medium text-red-600">
          {awayPoints}
        </td>
      </tr>
    </>
  );
};

export default StatsHeader;